var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticStyle:{"display":"contents"}},[_c('v-tab-item',[_vm._v("Tab1")]),_c('v-tab-item',[_vm._v("Tab2")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }